<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    @click:outside="dialog = false"
  >
    <v-card>
      <v-card-title>
        <span class="headline">削除確認</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        本当に "{{ title }}" を削除していいですか？<br>
        この操作は取り消しできません！
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog=false">キャンセル</v-btn>
        <v-btn color="error" @click="send" :loading="loading">はい、削除します</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      uuid: '',
      title: '',
      dialog: false,
      loading: false,
    }
  },
  methods: {
    open(item) {
      this.uuid = item.uuid
      this.title = item.title
      this.dialog = true
    },
    async send() {
      this.loading = true
      const accessToken = await this.$auth.getTokenSilently()
      await axios.delete(`/api/video/${this.uuid}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(() => {
        this.dialog = false
        this.$emit('success')
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false
      })
    },
  }
}
</script>